import {Input} from 'antd';
import * as React from 'react';
import {maxLengthInput} from '../../utils/constants';
import {ContactDetails} from './contact-details';

interface IProps {
    contactInfo: any;
    newPocId: number|string;
    updateNewPocId: (event: any) => void;
    rowClass: string;
    className: string;
    validationMessage?: string;
}

export function LinkedContactPopup({contactInfo, newPocId, updateNewPocId, rowClass, validationMessage, className}: IProps) {
    const renderContact = contactInfo && !(newPocId === '');
    return <div className={`${rowClass} formGroup`}>
        <div>
            {/*<span className="label">POCID </span>*/}
            <Input addonBefore='Contact Id' maxLength={maxLengthInput}
                   size='small' value={newPocId || ''} onChange={updateNewPocId}/>
            {validationMessage}
        </div>
        {renderContact && <ContactDetails contactInfo={contactInfo} className={className} />}
        {!renderContact && <div>No Contact</div>}
    </div>;
}
